import { omitNonAlphaNumericCharacters } from 'src/lib/string';

interface UploadFileToS3Params {
  url: string;
  file: File;
  onProgress?: (percentage: number) => void;
}

interface UploadFileToS3Result {
  checksum: string;
}

export const uploadFileToS3 = async ({
  url,
  file,
  onProgress,
}: UploadFileToS3Params): Promise<UploadFileToS3Result> =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url, true);
    xhr.upload.onprogress = (event: ProgressEvent) => {
      if (event.lengthComputable) {
        onProgress?.(Math.round((event.loaded / event.total) * 100));
      }
    };
    xhr.onload = () => {
      if (xhr.status === 200) {
        onProgress?.(100);

        const etag = xhr.getResponseHeader('Etag');
        resolve({ checksum: omitNonAlphaNumericCharacters(etag || '') });
      } else {
        reject(new Error('Upload failed with status ' + xhr.status));
      }
    };
    xhr.onerror = () => reject(new Error('Upload error'));
    xhr.send(file);
  });
